/**
 * @param {number} price
 * @param {string} [paramsOptions.currency]
 * @param {string} [paramsOptions.country]
 * @returns {string}
 */
export default (price, paramsOptions) => {
  if (typeof price !== 'number') {
    return null;
  }

  const defaultOptions = {
    currency: 'RUB',
    country: 'ru-RU',
    digitsComma: price.toString().includes('.') ? 2 : 0,
  };

  const options = { ...defaultOptions, ...paramsOptions };

  const { currency, country, digitsComma } = options;

  return new Intl.NumberFormat(country, {
    style: 'currency',
    currency,
    minimumFractionDigits: digitsComma,
    maximumFractionDigits: digitsComma,
  })
    .format(price)
    .replaceAll(/\u00A0/g, '\u2009');
};